import createReducer from '../utils/createReducer';
import {isEmpty} from 'lodash';
import actions from '../actions/actions';
import {
    setComponentState,
    deleteComponentState,
    setComponentPath,
    setDeepLinkParams,
    savePreferredLocale
} from '../utils/localStorageDataHandler';
import {isSWSv2FlowEnabled} from '../utils/commonUtil';

const initialState = {};
const actionHandlers = {
    [actions.FETCH_INITIAL_DATA_SUCCESS](state, {payload}) {
        const {
            appState,
            userType,
            authState,
            translations,
            publicUuid,
            footerData,
            ineligibilityStatusCode,
            config,
            ulxParams,
            pmscParams,
            supportedLocales,
            supportedBrands,
            brandSwitchParams,
            headerData,
            redirectPath,
            integratedBrandsPrimarySiteList,
            userEmailAddress,
            accountUuid,
            isConsolidationRequired,
            dyff
        } = payload.response;

        return {
            ...state,
            config,
            appState,
            userType,
            authState,
            translations,
            publicUuid,
            footerData,
            ineligibilityStatusCode,
            enableLoadOverlay: true,
            ulxParams,
            pmscParams,
            supportedLocales,
            supportedBrands,
            brandSwitchParams,
            headerData,
            redirectPath,
            integratedBrandsPrimarySiteList,
            userEmailAddress,
            accountUuid,
            isConsolidationRequired,
            dyff
        };
    },

    [actions.ENABLE_LOAD_OVERLAY](state, {payload}) {
        return {
            ...state,
            enableLoadOverlay: payload.flag
        };
    },

    [actions.CHANGE_APP_STATE](state, {payload}) {
        return {
            ...state,
            appState: payload.state
        };
    },

    [actions.SHOW_INELIGIBLE_FORM](state, {payload}) {
        return {
            ...state,
            appState: 'INELIGIBLE',
            ineligibilityFormStatus: payload.type
        };
    },

    [actions.SET_CAPTCHA_RESP](state, {payload}) {
        return {
            ...state,
            [`${payload.type}RecaptchaResp`]: payload.response
        };
    },

    [actions.SAVE_COMPONENT_STATE](state, {payload}) {
        setComponentState(state.publicUuid, payload.componentName, payload.componentState); // Save state in browser local storage
        return {
            ...state
        };
    },

    [actions.SAVE_COMPONENT_PATH](state, {payload}) {
        setComponentPath(state.publicUuid, payload.path); // Save path in browser local storage
        return {
            ...state
        };
    },

    [actions.GET_ABACUS_EXP_FLAG](state, {payload}) {
        const {experimentNames} = payload;
        let isSWSv2FlowEnabledFlag;

        if (!isEmpty(experimentNames)) {
            experimentNames.forEach((experimentName) => {
                switch (experimentName) {
                    case 'vrbo_qc_sws_v2_flow':
                        isSWSv2FlowEnabledFlag = isSWSv2FlowEnabled();
                        break;
                    default:
                        isSWSv2FlowEnabledFlag = 0;
                }
            });
        }

        return {
            ...state,
            isSWSv2FlowEnabledFlag
        };
    },

    [actions.SHOW_SAVE_AND_FINISH_MODAL](state, {payload}) {
        return {
            ...state,
            isSaveModalOpen: payload.flag
        };
    },

    [actions.DELETE_COMPONENT_STATE](state, {}) {
        deleteComponentState(state.publicUuid);
        return {
            ...state
        };
    },

    [actions.SAVE_DEEP_LINK_PARAMS](state, {payload}) {
        setDeepLinkParams(payload.paramType, payload.deepLinkParams); // Save deep Link params in browser local storage
        return {
            ...state
        };
    },
    [actions.SAVE_PREFERRED_LOCALE](state, {payload}) {
        const {publicUuid, locale} = payload;
        savePreferredLocale(publicUuid, locale);
        return {
            ...state
        };
    },
};

export default createReducer(actionHandlers, initialState);
